<template>
  <div :class="['footer', {'is-flag': $flag}]">
    <div class="footer-content">
      <div class="footer-main container">
        <div class="footer-brand">
          <img class="footer-logo" src="./assets/images/logo.png" alt="Huitu Tech">
          <p class="brand-desc">汇图科技致力于提高医疗机构信息化、移动化水平及跨院业务协作，打造专业影像云+人工智能应用平台。</p>
          <div class="brand-tags">
            <span>开放</span>
            <span>包容</span>
            <span>专业</span>
            <span>创新</span>
          </div>
        </div>
        
        <div class="footer-links">
          <div class="link-group">
            <h4 class="link-title">联系我们</h4>
            <ul class="contact-list">
              <li v-for="(item, index) in info" :key="index">
                <i :class="item.icon"></i>
                <span class="contact-text">{{ item.text }}</span>
              </li>
            </ul>
          </div>
          
          <div class="footer-qrcode">
            <h4 class="link-title">关注我们</h4>
            <div class="qrcode-wrapper">
              <img src="./assets/images/qrcode_for_gh_e33ab65b03e5_344.jpg" alt="QR Code">
              <p>扫码关注公众号</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="container bottom-content">
          <p class="copyright">Copyright © 2023-2025 汇图科技（浙江）有限公司</p>
          <div class="beian-group">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33118102000481" target="_blank" class="beian">
              浙公网安备33118102000481号
            </a>
            <a href="https://beian.miit.gov.cn/" target="_blank" class="beian">浙ICP备2023019936号-1</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterOut',
  data() {
    return {
      info: [
        {
          icon: 'el-icon-phone-outline',
          text: '18969585538'
        },
        {
          icon: 'el-icon-message',
          text: 'contact@huitutech.com'
        },
        {
          icon: 'el-icon-link',
          text: 'www.huitutech.com'
        },
        {
          icon: 'el-icon-location-outline',
          text: '浙江省丽水市龙泉市剑池街道瓯江花园1-134室'
        },
      ]
    }
  }
};
</script>

<style lang="less" scoped>
@import './assets/css/index.less';
</style>
